/**
 * Use Case: Import Voucherku
 * Business logic for importing a Voucherku product as a reward.
 */

import type { ImportVoucherkuPayload, ImportVoucherkuResult } from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Import a Voucherku product as a reward
 * @param payload - The voucherku import payload
 */
export const ImportVoucherkuUseCase = async (
  payload: ImportVoucherkuPayload
): Promise<ImportVoucherkuResult> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.importVoucherku(payload);
};

